import map from 'lodash/map';
import merge from 'lodash/merge';

import { showHelpDialog } from 'shared/redux/actions';
import { getStore } from 'shared/redux/store';

// DEPRECATED - use shared/oomponents/button/HelpButton
export const createHelpIcon = (content_, options = {}) => {
  const content = {
    header: '',
    body: '',
    ...content_,
  };
  return new HelpIcon(content, options);
};

class HelpIcon {
  constructor(content, options) {
    this.header = content.header;
    this.body = content.body;
    this.options = merge(options, {
      class: 'help-icon',
      src: '/images/help.svg',
    });

    return this.render();
  }

  render() {
    let styles = '';
    map(this.options.styles, function (value, key) {
      styles += `${key}:${value};`;
    });

    const props = merge(this.options, {
      style: styles,
    });

    return window.$('<img/>', props).on('click', this.onIconClick.bind(this));
  }

  onIconClick() {
    getStore().dispatch(showHelpDialog(this.header, this.body));
  }
}
